import { ErrorBoundary } from '@shared/components/common/ErrorBoundary';
import { Button } from '@shared/components/ui/button';
import { Building2, RefreshCw, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Custom fallback UI for properties feature errors
 */
function PropertiesErrorFallback({ onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center min-h-[300px] bg-white rounded-2xl">
      <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
        <Building2 className="w-8 h-8 text-amber-600" />
      </div>
      <h2 className="text-lg font-semibold text-slate-900 mb-2">
        تعذر تحميل العقارات
      </h2>
      <p className="text-slate-500 mb-6 max-w-md">
        حدث خطأ أثناء تحميل بيانات العقارات. يرجى المحاولة مرة أخرى.
      </p>
      <div className="flex gap-3">
        <Button onClick={onRetry} className="gap-2 bg-emerald-600 hover:bg-emerald-700">
          <RefreshCw className="w-4 h-4" />
          إعادة المحاولة
        </Button>
        <Link to="/">
          <Button variant="outline" className="gap-2">
            <Home className="w-4 h-4" />
            الرئيسية
          </Button>
        </Link>
      </div>
    </div>
  );
}

/**
 * Error boundary specifically for the Properties feature
 * Provides feature-specific error handling and UI
 */
export function PropertiesErrorBoundary({ children }) {
  const handleError = (error, errorInfo) => {
    // Log to console in development
    if (import.meta.env.DEV) {
      console.error('[Properties Feature Error]', error, errorInfo);
    }

    // TODO: Send to error tracking service (Sentry, etc.)
  };

  return (
    <ErrorBoundary
      fallback={<PropertiesErrorFallback onRetry={() => window.location.reload()} />}
      onError={handleError}
    >
      {children}
    </ErrorBoundary>
  );
}
